import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import generalStyle from "../GeneralStyles";

export const CheckBoxContainer = ({ options, text }) => {
  const checkBoxBlock = StyleSheet.create({
    optionNotSelected: {
      width: 15,
      height: 15,
      backgroundColor: "white",
      border: "1 solid black",
      marginLeft: 8,
    },
    text: {
      fontSize: 10,
    },
    optionText: {
      fontSize: 10,
      marginLeft: 3,
    },
    optionWrapper: {
      ...generalStyle.inLineBlocks,
      marginRight: 16,
    },
    container: {
      ...generalStyle.inLineBlocks,
      marginTop: 7,
    },
  });

  return (
    <View data-testid="checkbox-container" style={checkBoxBlock.container}>
      <Text style={checkBoxBlock.text}>{text}</Text>
      {options?.map((option, index) => (
        <View key={index} style={checkBoxBlock.optionWrapper}>
          <Text style={checkBoxBlock.optionText}>{option}</Text>
          <View style={checkBoxBlock.optionNotSelected} />
        </View>
      ))}
    </View>
  );
};
